<template>
  <v-app>
    <template v-if="contentsOnly">
      <!-- content -->
      <v-content>
        <router-view />
      </v-content>
    </template>
    <template v-else>
      <!-- header -->
      <the-header />

      <!-- sidebar -->
      <the-sidebar @sidebar="onChangeSidebar" />

      <!-- content -->
      <v-content
        class="mt-5"
        :style="{
          paddingLeft: !isLogined ? '0px' : isSidebarOpen ? '256px' : '56px',
        }"
      >
        <router-view />
      </v-content>

      <!-- footer -->
      <the-footer />
    </template>
  </v-app>
</template>

<script>
import TheHeader from '@/components/layout/TheHeader.vue'
import TheFooter from '@/components/layout/TheFooter.vue'
import TheSidebar from '@/components/layout/TheSidebar.vue'

import {mapMutations, mapGetters} from 'vuex'

export default {
  name: 'App',
  data: () => ({
    isSidebarOpen: false,
  }),
  computed: {
    ...mapGetters({
      isLogined: 'auth/isLogined',
    }),
    contentsOnly: function() {
      return !this.$route.name || this.$route.name === 'brains_viewer'
    },
  },
  components: {
    TheHeader,
    TheFooter,
    TheSidebar,
  },
  methods: {
    ...mapMutations({
      setUserProfile: 'auth/setUserProfile',
    }),
    onChangeSidebar(isOpen) {
      this.isSidebarOpen = isOpen
    },
    async setProfile() {
      const profile = await this.getMyAccount()
      this.setUserProfile(profile)
    },
  },
  watch: {
    isLogined(val) {
      if (val) {
        this.setProfile()
      }
    },
  },
  mounted() {
    if (this.isLogined) {
      this.setProfile()
    }
  },
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Open+Sans:400,700,800&display=swap');
@import '@/assets/scss/animation';

.project_name {
  font-family: 'Open Sans';
  color: #fff !important;
}
.v-slide-group__prev--disabled {
  display: none !important;
}
.bg-dark {
  background-color: #24292e !important;
}
.crs-p {
  cursor: pointer;
}
.v-content {
  margin-bottom: 3rem;
}
.container {
  padding-left: 20px;
  padding-right: 20px;
  margin-bottom: 100px;
}
</style>
